import { atom } from 'recoil';
import type { AllCoverablesDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote/';
import { localStorageReceipt } from '../effects/localStorageReceipt';
import { coverablesSelector } from '../selectors/coverablesSelector';

export const allCoverablesAtom = atom<AllCoverablesDTO>({
    key: 'coverables',
    default: coverablesSelector,
    effects: [localStorageReceipt('allcoverablesdto')]
});
